import { formatCurrency } from './currency';

export enum OutputValueType {
  PERCENTAGE = 'PERCENTAGE',
  MONEY = 'MONEY',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export const getFormattedCalculatedValue = (
  outputValueType: OutputValueType,
  outputValueSymbol: string | undefined,
  value: number | string
) => {
  if (outputValueType === OutputValueType.TEXT && typeof value === 'string') {
    return value;
  }

  if (outputValueType === OutputValueType.MONEY && outputValueSymbol) {
    return formatCurrency(value, outputValueSymbol);
  }
  if (outputValueType === OutputValueType.PERCENTAGE && outputValueSymbol) {
    return `${value}${outputValueSymbol}`;
  }
  return String(value);
};
